import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DocLayout } from "./components/layout/DocLayout";
import { Overview } from "./pages/Overview";
import { GettingStarted } from "./pages/GettingStarted";
import { Authentication } from "./pages/Authentication";
import { Collections } from "./pages/Collections";
import { Payouts } from "./pages/Payouts";
import { AccountManagement } from "./pages/AccountManagement";
import { GatewayCheckout } from "./pages/GatewayCheckout";
import { GatewayWebhook } from "./pages/GatewayWebhook";
import { BillPayment } from "./pages/BillPayment";
import { CustomerCrypto } from "./pages/CustomerCrypto";
import ScrollToTop from "./components/commons/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <DocLayout>
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/getting-started" element={<GettingStarted />} />
          <Route path="/authentication" element={<Authentication />} />
          <Route path="/collections/*" element={<Collections />} />
          <Route path="/payouts/*" element={<Payouts />} />
          <Route path="/account/*" element={<AccountManagement />} />
          <Route path="/gateway-checkout" element={<GatewayCheckout />} />
          <Route path="/bill-payment/*" element={<BillPayment />} />
          <Route path="/customer-crypto/*" element={<CustomerCrypto />} />
          {/* <Route path="/gateway-checkout/webhook" element={<GatewayWebhook />} /> */}
        </Routes>
      </DocLayout>
    </Router>
  );
}

export default App;
